import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { firstValueFrom } from 'rxjs'
import { environment } from '@env'
import { GetDoubtsRequest, GetDoubtsResponse, SaveDoubtRequest, Doubt } from '@models'

@Injectable({
  providedIn: 'root',
})
export class DoubtService {
  private readonly baseUrl = `${environment.api.baseUrl}/content/v1/doubts`

  constructor(private http: HttpClient) {}

  async getAll(params?: GetDoubtsRequest): Promise<GetDoubtsResponse> {
    let httpParams = new HttpParams()

    if (params) {
      if (params.page !== undefined) httpParams = httpParams.set('page', params.page.toString())

      if (params.pageSize !== undefined) httpParams = httpParams.set('pageSize', params.pageSize.toString())

      if (params.text) httpParams = httpParams.set('text', params.text)

      if (params.orderBy) httpParams = httpParams.set('orderBy', params.orderBy)

      if (params.order) httpParams = httpParams.set('order', params.order)

      if (params.status !== undefined && params.status !== null)
        httpParams = httpParams.set('status', String(params.status))

      if (params.visibility) httpParams = httpParams.set('visibility', params.visibility)

      if (params.topics) httpParams = httpParams.set('topics', params.topics)

      if (params.url) httpParams = httpParams.set('url', params.url)

      const hasStart = !!params.startModifiedDate
      const hasEnd = !!params.endModifiedDate

      if (hasStart && hasEnd) {
        httpParams = httpParams
          .set('startModifiedDate', params.startModifiedDate!)
          .set('endModifiedDate', params.endModifiedDate!)
      }
    }

    const response = await firstValueFrom(this.http.get<GetDoubtsResponse>(this.baseUrl, { params: httpParams }))
    return response
  }

  async getById(id: string): Promise<Doubt> {
    const response = await firstValueFrom(this.http.get<Doubt>(`${this.baseUrl}/${id}`))
    return response
  }

  async create(payload: SaveDoubtRequest): Promise<Doubt> {
    const response = await firstValueFrom(this.http.post<Doubt>(this.baseUrl, payload))
    return response
  }

  async update(id: string, payload: SaveDoubtRequest): Promise<Doubt> {
    const response = await firstValueFrom(this.http.put<Doubt>(`${this.baseUrl}/${id}`, payload))
    return response
  }

  async delete(id: string): Promise<void> {
    const response = await firstValueFrom(this.http.delete<void>(`${this.baseUrl}/${id}`))
    return response
  }
}
